import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import * as actions from './store/loader.actions';
import { LoadingState } from './store/loader.reducer';

@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private store: Store<LoadingState>) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.store.dispatch(actions.showLoader());

    return next.handle(req).pipe(
      finalize(() => {
        this.store.dispatch(actions.hideLoader());
      }),
    );
  }
}
